import { PensionPhaseStatus } from "@repo/api";
import { cs } from "@repo/ui";
import { type FC } from "react";
import Attention from ".";

type RecurringPaymentProps = {
    pensionPhaseStatus?: PensionPhaseStatus;
};

const RecurringPayment: FC<RecurringPaymentProps> = ({ pensionPhaseStatus }) => {
    return (
        <>
            {pensionPhaseStatus === PensionPhaseStatus.Payout ? (
                <Attention severity="info">{cs.global["terminated-contract-info"]}</Attention>
            ) : (
                <Attention severity="info" title="Trvalý příkaz">
                    {cs.global["recurring-payment-info"]}
                </Attention>
            )}
        </>
    );
};

export default RecurringPayment;
